
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import AuthRoutes from './auth/AuthRoutes';
import ManagerRoutes from './manager/ManagerRoutes';
import EmployeeRoutes from './employee/EmployeeRoutes';
import AdminRoutes from './admin/AdminRoutes';
import PublicReportRoutes from './Reports/PublicReportRoutes';

import ProtectedRoute from './ProtectedRoute';
import DashboardLayout from '../layouts/DashboardLayout';

import RouteLoader from '../components/Loader/RouteLoader';

import NotFound from '../features/dashboard/pages/NotFound';
import TestPage from '../features/dashboard/pages/Test';

const isPublicReportRoute = (pathname: string): boolean =>
  pathname === '/public-report' ||
  pathname.startsWith('/public-report/');

const RouteLoaderWrapper = () => {
  const location = useLocation();

  if (isPublicReportRoute(location.pathname)) {
    return null;
  }

  return <RouteLoader />;
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <RouteLoaderWrapper />

      <Routes>
        {/* AUTHENTICATION */}
        {AuthRoutes()}

        {/* TEST */}
        <Route path="/test" element={<TestPage />} />

        {/* PUBLIC REPORTS */}
        {PublicReportRoutes()}

        {/* PROTECTED APPLICATION */}
        <Route element={<ProtectedRoute />}>
          {/* ADMIN / WFM - Uses its own page layout and sidebar */}
          {AdminRoutes()}

          {/* EXISTING EMPLOYEE / MANAGER LAYOUT */}
          <Route element={<DashboardLayout />}>
            {/* MANAGER */}
            {ManagerRoutes()}

            {/* EMPLOYEE */}
            {EmployeeRoutes()}
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
